import React from 'react'
import { Button, Form, FormGroup, ListGroup, ListGroupItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import CheckIcon from 'react-icons/lib/fa/check'

class SubscriptionControllerForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dropdownOpen: true,
            selectSUbId: null
        };
        this.onSubmit = props.onSubmit
        this.handleSubmit = this.handleSubmit.bind(this)
        this.toggle = this.toggle.bind(this);
        this.onSubClickHandler = this.onSubClickHandler.bind(this)
    }

    handleSubmit = (e) => {
        e.preventDefault()
        const { selectSubsId, selectSubsName, subsSeasoned } = this.state
        let controllerId = sessionStorage.controllerId
        this.onSubmit(selectSubsId, selectSubsName, subsSeasoned, controllerId)
        sessionStorage.controllerId = null
    }

    toggle() {
        this.setState(prevState => ({
            dropdownOpen: true
        }));
    }

    onSubClickHandler(subsId, subsName, is_easoned) {
        this.setState({
            selectSubsId: subsId,
            selectSubsName: subsName,
            subsSeasoned: is_easoned
        })
    }

    render() {
        let { planData } = this.props
        return (
            <Form onSubmit={this.handleSubmit} className="col-lg-12 col-md-12 col-sm-10">
                <FormGroup>
                    <ListGroup>
                        {planData.data.map((p) => (
                            <ListGroupItem
                                key={`subs-${p.id}`}
                                onClick={this.onSubClickHandler.bind(this, p.id, p.name, p.is_seasoned)}
                                disabled={this.state.selectSubsId == p.id}>
                                {(this.state.selectSubsId == p.id ?
                                    <span className="text-primary"><CheckIcon /></span> :
                                    null)}
                                &nbsp;{p.name}
                            </ListGroupItem>
                        ))}
                    </ListGroup>
                    <br />
                </FormGroup>
                <Button>Save</Button>
            </Form>
        )
    }
}

export default SubscriptionControllerForm


// WEBPACK FOOTER //
// ./src/components/ui/SubscriptionControllerForm.js